export default __webpack_public_path__ + "static/media/icons8-manual-handling.71c7ee64.svg";